import { render } from "./SessionEditForm.vue?vue&type=template&id=4926f1f6&scoped=true"
import script from "./SessionEditForm.vue?vue&type=script&lang=js"
export * from "./SessionEditForm.vue?vue&type=script&lang=js"

import "./SessionEditForm.vue?vue&type=style&index=0&id=4926f1f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4926f1f6"]])

export default __exports__